import React, { useEffect, useState } from 'react';
import { BACKEND_URL } from '../config/features';
import { mirrorSessionRemoval, mirrorSessionValue } from '../mobile/session';

const ACCESS_CODE_KEY = 'correfood_access_code';

async function verifyAccessCode(code) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (code) {
    headers['X-Access-Code'] = code;
  }

  const response = await fetch(`${BACKEND_URL}/api/access/verify`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ code: code || '' }),
  });

  if (response.ok) {
    return await response.json().catch(() => ({ ok: true, enabled: true }));
  }

  const payload = await response.json().catch(() => ({}));
  const message = payload?.detail || 'Codigo de acesso invalido';
  const error = new Error(message);
  error.status = response.status;
  throw error;
}

function AccessGate({ children }) {
  const [status, setStatus] = useState('checking');
  const [error, setError] = useState('');
  const [codeInput, setCodeInput] = useState('');

  useEffect(() => {
    let active = true;

    const init = async () => {
      const stored = localStorage.getItem(ACCESS_CODE_KEY);

      try {
        const result = await verifyAccessCode(stored || '');

        if (!active) return;

        if (result?.enabled === false) {
          setStatus('open');
          return;
        }

        if (stored) {
          setStatus('open');
          return;
        }

        setStatus('locked');
      } catch (err) {
        if (!active) return;

        if (stored) {
          localStorage.removeItem(ACCESS_CODE_KEY);
          void mirrorSessionRemoval([ACCESS_CODE_KEY]);
          setError('Codigo invalido. Tente novamente.');
        }

        setStatus('locked');
      }
    };

    init();

    return () => {
      active = false;
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    try {
      const result = await verifyAccessCode(codeInput.trim());

      if (result?.enabled === false) {
        setStatus('open');
        return;
      }

      localStorage.setItem(ACCESS_CODE_KEY, codeInput.trim());
      void mirrorSessionValue(ACCESS_CODE_KEY, codeInput.trim());
      setStatus('open');
    } catch (err) {
      setError(err?.message || 'Codigo invalido.');
    }
  };

  if (status === 'open') {
    return children;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f6f6f6',
        padding: '24px',
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: '100%',
          maxWidth: '420px',
          background: '#fff',
          borderRadius: '16px',
          padding: '28px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
        }}
      >
        <h2 style={{ margin: 0, fontSize: '22px', color: '#1b1b1b' }}>
          Acesso restrito
        </h2>
        <p style={{ marginTop: '8px', color: '#666', fontSize: '14px' }}>
          Digite o codigo de acesso para continuar.
        </p>

        <input
          type="password"
          value={codeInput}
          onChange={(event) => setCodeInput(event.target.value)}
          placeholder="Codigo de acesso"
          style={{
            width: '100%',
            marginTop: '16px',
            padding: '12px 14px',
            borderRadius: '10px',
            border: '1px solid #ddd',
            fontSize: '15px',
          }}
        />

        {error ? (
          <div style={{ color: '#c0392b', fontSize: '14px', marginTop: '10px' }}>
            {error}
          </div>
        ) : null}

        <button
          type="submit"
          style={{
            width: '100%',
            marginTop: '16px',
            padding: '12px',
            borderRadius: '10px',
            border: 'none',
            background: '#ff6b00',
            color: '#fff',
            fontWeight: '600',
            fontSize: '15px',
            cursor: 'pointer',
          }}
        >
          Entrar
        </button>
      </form>
    </div>
  );
}

export default AccessGate;
